(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_508bd83"] && !Shopify.designMode) return;
  try {
    class ScrollVideo extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('.scroll-video__video'));
      if (!this.videos.length) return;

      this.current = 0;
      this.lastSet = -1;
      this.rafId = null;
      this.endFraction = (parseFloat(this.dataset.playbackEnd) || 100) / 100;
      this.visible = false;
      this.tick = this.tick.bind(this);
      this.kick = this.kick.bind(this);
      this._onResize = () => { this.setActive(); this.kick(); };

      this.videos.forEach((v) => {
        v.addEventListener('loadedmetadata', () => {
          v.currentTime = 0.001;                            // paint first frame
          v.play().then(() => v.pause()).catch(() => {});   // iOS seek unlock
          this.kick();
        });
      });

      this.setActive();
      window.addEventListener('resize', this._onResize);
      // djtt: the loop sleeps once the video catches up; scrolling wakes it.
      // Capture on document, because on desktop 4.3 scrolls .page-wrapper and the window never fires scroll
      document.addEventListener('scroll', this.kick, { capture: true, passive: true });
      document.addEventListener('scrollend', this.kick, { capture: true, passive: true });

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          this.visible = e.isIntersecting;
          if (e.isIntersecting) {
            this.kick();
          } else if (this.rafId !== null) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }
        });
      }, { threshold: 0 });
      this.io.observe(this);

      // djtt: fetch the video only when the section is within 800px, not at page load
      this.near = false;
      this.loadIo = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.near = true;
        this.loadIo.disconnect();
        this.loadActive();
      }, { rootMargin: '800px 0px' });
      this.loadIo.observe(this);
    }

    disconnectedCallback() {
      if (this.rafId !== null) cancelAnimationFrame(this.rafId);
      if (this.io) this.io.disconnect();
      if (this.loadIo) this.loadIo.disconnect();
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('scroll', this.kick, true);
      document.removeEventListener('scrollend', this.kick, true);
    }

    kick() {
      if (this.visible && this.rafId === null) this.rafId = requestAnimationFrame(this.tick);
    }

    // Use whichever video is visible for this breakpoint; its source loads once the section is near.
    setActive() {
      const visible = this.videos.find((v) => v.getClientRects().length) || this.videos[0];
      if (visible === this.video) return;
      this.video = visible;
      this.lastSet = -1; // force a re-seek on the newly active video
      this.loadActive();
    }

    loadActive() {
      if (!this.near || !this.video) return;
      if (!this.video.getAttribute('src') && this.video.dataset.src) {
        this.video.src = this.video.dataset.src;
      }
    }

    progress() {
      const rect = this.getBoundingClientRect();
      const scrollable = this.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
      return scrollable > 0 ? scrolled / scrollable : 0;
    }

    tick() {
      const v = this.video;
      const duration = v.duration || 0;
      const target = this.progress() * duration * this.endFraction;
      this.current += (target - this.current) * 0.12; // lerp for smooth fast scrolls
      if (Math.abs(target - this.current) < 0.001) this.current = target;
      if (duration && !v.seeking && Math.abs(this.current - this.lastSet) > 0.01) {
        v.currentTime = this.current;
        this.lastSet = this.current;
      }
      // Sleep once caught up with nothing left to seek; keep going while a seek is pending
      const settled = this.current === target && (!duration || Math.abs(this.current - this.lastSet) <= 0.01);
      this.rafId = settled ? null : requestAnimationFrame(this.tick);
    }
  }

  if (!customElements.get('scroll-video')) {
    customElements.define('scroll-video', ScrollVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
